import React from "react";
import "./home-content.scss";
import { Carousel } from "antd";
import { FcNext, FcPrevious } from 'react-icons/fc';
import { Activity } from "../../../components/activity";
import mainCenter from '../../../assets/photos/anasayfa/main.jpg';
import mainLeft from '../../../assets/photos/anasayfa/main_1.jpg';
import mainRight from '../../../assets/photos/anasayfa/main_2.jpg';
import AliYakubBabanınEserleri from '../../../assets/books/kapaklar/yakub-babanin-eserleri.jpg';
import sema from '../../../assets/photos/anasayfa/sema.jpg';
import arafat from '../../../assets/photos/anasayfa/hacc.jpg';
import sebiArus from '../../../assets/photos/anasayfa/sebi-arus.jpg';
import mukabele from '../../../assets/photos/anasayfa/mukabele.jpg';
import itikaf from '../../../assets/photos/anasayfa/itikaf.jpg';
import allahinHidayetGunesi from '../../../assets/photos/anasayfa/allahin-hidayet-gunesi.jpg';

interface HomeContentProps {

}
interface HomeContentState {
    Change: boolean;
}

class HomeContent extends React.Component<HomeContentProps, HomeContentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    getOriginUrl = () => {
        const pagesUrls = {
            semaUrl: "/sema",
            booksUrl: "/books",
            haccUrl: "/hacc-hatiralari",
            itikafUrl: "/itikaf-hatiralari",
            galeriUrl: "/galeri",
            mukabeleUrl: "/mukabele",
            hidayetUrl: "/allahin-hidayet-gunesi",
        };

        return pagesUrls;
    }

    render() {
        const PagesUrls = this.getOriginUrl();
        return (
            <div className="home-content">
                <div className="carousel-content">
                    <div className="sliders">
                        <Carousel
                            arrows={true}
                            prevArrow={<FcPrevious fontSize={24} />}
                            nextArrow={<FcNext fontSize={24} />}
                            autoplay={true}
                            infinite
                        >
                            <div className="slide-box">
                                <img src={mainLeft} alt="Sema" />
                            </div>

                            <div className="slide-box">
                                <img src={mainRight} alt="Sema" />
                            </div>

                            <div className="slide-box">
                                <img src={mainCenter} alt="Sema" />
                            </div>
                        </Carousel>
                    </div>
                </div>
                <section className="our-activities">
                    <h3 className="activities-title">FAALİYETLERİMİZ</h3>

                    <div className="activities-content book-activity">
                        <Activity
                            activityTitle="Eserlerimiz"
                            imageSource={AliYakubBabanınEserleri}
                            imageTitle="Eserlerimiz"
                            link={PagesUrls.booksUrl}
                            linkTitle="SAYFAYA GİT"
                            isImageBordered={true}
                            className="book"
                        />
                    </div>

                    <div className="activities-content">
                        <Activity
                            activityTitle="Sema"
                            imageSource={sema}
                            imageTitle="Sema"
                            link={PagesUrls.semaUrl}
                            linkTitle="SAYFAYA GİT"
                        />
                        <Activity
                            activityTitle="Hacc"
                            imageSource={arafat}
                            imageTitle="Hacc"
                            link={PagesUrls.haccUrl}
                            linkTitle="SAYFAYA GİT"
                        />

                        <Activity
                            activityTitle="İtikaf"
                            imageSource={itikaf}
                            imageTitle="İtikaf"
                            link={PagesUrls.itikafUrl}
                            linkTitle="SAYFAYA GİT"
                        />

                        <Activity
                            activityTitle="Şeb-i Arus Programları"
                            imageSource={sebiArus}
                            imageTitle="Şeb-i Arus Programları"
                            link={PagesUrls.galeriUrl}
                            linkTitle="SAYFAYA GİT"
                        />

                        <Activity
                            activityTitle="Mukabele-i Şerif"
                            imageSource={mukabele}
                            imageTitle="Mukabele-i Şerif"
                            link={PagesUrls.mukabeleUrl}
                            linkTitle="SAYFAYA GİT"
                        />
                        <Activity
                            activityTitle="Allah'ın Hidayet Güneşi'nin Doğması"
                            imageSource={allahinHidayetGunesi}
                            imageTitle="Allah'ın Hidayet Güneşi'nin Doğması"
                            link={PagesUrls.hidayetUrl}
                            linkTitle="SAYFAYA GİT"
                        />
                    </div>

                    <div className="activities-content mukabele-activity">

                    </div>
                </section>
            </div >
        );
    }
}

export default HomeContent;